export class CryptoCurrency {
    static BTC = 'BTC';
    static ETH = 'ETH';
    static TRX = 'TRX';
}